import { createFileRoute } from '@tanstack/react-router'

import { Verifications } from '@/widgets/case-management/verifications'

export const Route = createFileRoute('/_app/case-management/verifications/')({
  component: RouteComponent,
})

export const CaseManagementVerificationsRoute = Route

function RouteComponent() {
  return <Verifications />
}
